import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../../ui/dialog";

// Confirmacao textual exigida tambem pelo backend (o backend revalida tudo).
export const ConfirmDialog = ({ open, onClose, title, description, confirmText, withReason, onConfirm, busy }) => {
  const [typed, setTyped] = useState("");
  const [reason, setReason] = useState("");
  const close = () => { setTyped(""); setReason(""); onClose(); };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && close()}>
      <DialogContent data-testid="pc-confirm-dialog">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        {withReason && (
          <textarea value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Motivo da alteracao (auditoria)"
            className="w-full border border-[#EBE5DF] p-2 text-sm" rows={2} data-testid="pc-confirm-reason" />
        )}
        <label className="text-xs text-[#5C5A57]">Digite <b>{confirmText}</b> para confirmar</label>
        <input value={typed} onChange={(e) => setTyped(e.target.value)} className="w-full border border-[#EBE5DF] p-2 text-sm"
          data-testid="pc-confirm-input" />
        <DialogFooter>
          <button className="ghost" onClick={close} data-testid="pc-confirm-cancel">Cancelar</button>
          <button className="brand" disabled={busy || typed.trim().toUpperCase() !== confirmText}
            onClick={async () => { if (await onConfirm(typed, reason)) close(); }} data-testid="pc-confirm-submit">
            {busy ? "Aplicando..." : "Confirmar"}
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
